import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DevOpsVisualizer from "./pages/DevOpsVisualizer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DevOpsVisualizer />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
